// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"Skeleton_skeleton__54p8o","fadeIn":"Skeleton_fadeIn__byQaq"};